import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ManagerErrorCode } from '@new/common/utils/error-parser';
import { managerErrorTranslationMap } from '@new/common/utils/error-translation-map';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { MODAL_DATA } from '../modal.service';

export interface ErrorModalData {
  errorCode: ManagerErrorCode;
  message?: string;
}

@Component({
  templateUrl: './error-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, CommonModule]
})
export class ErrorModalComponent {
  public readonly translationKey: string;
  public readonly errorMessage: string;

  constructor(
    private ngbActiveModal: NgbActiveModal,
    @Inject(MODAL_DATA) public data: ErrorModalData
  ) {
    this.translationKey =
      managerErrorTranslationMap.get(data.errorCode) ??
      'state_error.general_error';
    this.errorMessage = data.message ?? '';
  }

  public onRetry(): void {
    this.ngbActiveModal.close();
  }

  public onCancel(): void {
    this.ngbActiveModal.dismiss();
  }
}
